export const locationReload = () => {
  window.location.reload()
}

export const changeLocationHref = (href: string) => {
  window.location.href = href
}
